// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"261":"1d17e60c765a6025","2475":"1d17e60c765a6025","2888":"d1a91f4eee7ac59d"}[chunkId] + ".css";
};